import { supabaseClient } from "@/supabase/app";
import { enqueueSnackbar } from "notistack";
export interface Campaign {
  id?: number;
  name: string;
  stats?: any;
  admin_name: string;
  status?: string;
  is_active?: boolean;
  is_new?: boolean;
  message_type: string;
  created_at?: Date;
  campaign_targetMarkets?: TargetMarkets[];
}
interface TargetMarkets {
  targetMarkets: TargetMarket;
}

interface TargetMarket {
  id: number;
  name?: string;
}

export interface CampaignMessages {
  id?: number;
  subject: string;
  message: string;
  campaign_id: number;
  sequence_id?: number; // Add sequence_id here
  user_id?: number;
  created_at?: string;
  message_id?: number;
}

export async function addCampaignMessage(campaignMessage: CampaignMessages) {
  try {
    const { data, error } = await supabaseClient
      .from("email_templates")
      .insert([
        {
          subject: campaignMessage?.subject,
          message: campaignMessage?.message,
          campaign_id: campaignMessage?.campaign_id,
          sequence_id: campaignMessage?.sequence_id,
        },
      ]);

    if (error) {
      throw error;
    }

    enqueueSnackbar("Message saved successfully!", {
      variant: "success",
    });
    return data;
  } catch (error) {
    enqueueSnackbar(`Error saving message: ${error.message}`, {
      variant: "error",
    });
  }
}

export async function deleteCampaignMessage(messageId: number) {
  try {
    const { data, error } = await supabaseClient
      .from("email_templates")
      .delete()
      .eq("id", messageId);

    if (error) {
      throw error;
    }

    enqueueSnackbar("Message deleted successfully!", {
      variant: "success",
    });
    return data;
  } catch (error) {
    enqueueSnackbar(`Error deleting message: ${error.message}`, {
      variant: "error",
    });
  }
}

export async function addPublishedMessage(
  id: Number,
  campaignMessage: CampaignMessages
) {
  try {
    const { data, error } = await supabaseClient
      .from("published_templates")
      .insert([
        {
          subject: campaignMessage?.subject,
          message: campaignMessage?.message,
          campaign_id: campaignMessage?.campaign_id,
          user_id: campaignMessage?.user_id,
          message_id: id,
          sequence_id: campaignMessage?.sequence_id,
        },
      ]);

    if (error) {
      throw error;
    }

    enqueueSnackbar("Message saved successfully!", {
      variant: "success",
    });
    return data;
  } catch (error) {
    enqueueSnackbar(`Error saving message: ${error.message}`, {
      variant: "error",
    });
  }
}


  export async function isPublishedMessageExists(messageId: number) {
  try {
    const { data, error } = await supabaseClient
      .from("published_templates")
      .select("id")
      .eq("message_id", messageId)
      .limit(1);

    if (error) {
      throw error;
    }

    // Return true if data exists, false otherwise
    if(data && data.length > 0){
      return true;
    }
    else{
      return false;
    }
  } catch (error) {
    enqueueSnackbar(`Error checking published message: ${error.message}`, {
      variant: "error",
    });
    return false; // Assume it doesn't exist on error
  }
}

export async function editPublishedMessage(
  id: number,
  campaignMessage: CampaignMessages
) {
  console.log("in edit publihs");

  console.log(id);
  try {
    console.log("id is" + id);
    const { data, error: updateError } = await supabaseClient
      .from("published_templates")
      .update({
        subject: campaignMessage.subject,
        message: campaignMessage.message,
        sequence_id: campaignMessage.sequence_id, // Include sequence ID if necessary
      })
      .eq("message_id", id);

    if (updateError) {
      throw updateError;
    }

    enqueueSnackbar("Published message updated successfully!", {
      variant: "success",
    });
    return data;
  } catch (error) {
    enqueueSnackbar(`Error saving message: ${error.message}`, {
      variant: "error",
    });
  }
}

export async function saveTemplate(campaignMessage: CampaignMessages) {
  try {
    // First, check if the template already exists
    const { data: existingTemplate, error: checkError } = await supabaseClient
      .from("saved_email_templates")
      .select("*")
      .eq("campaign_id", campaignMessage?.campaign_id)
      .eq("user_id", campaignMessage?.user_id)
      .eq("message_id", campaignMessage?.message_id)
      .single(); // Use .single() to get only one record

    if (checkError && checkError.code !== "PGRST116") {
      throw checkError;
    }

    let response;

    if (existingTemplate) {
      // If the template exists, update it
      const { data, error: updateError } = await supabaseClient
        .from("saved_email_templates")
        .update({
          subject: campaignMessage?.subject,
          message: campaignMessage?.message,
        })
        .eq("campaign_id", campaignMessage?.campaign_id)
        .eq("user_id", campaignMessage?.user_id)
        .eq("message_id", campaignMessage?.message_id);

      if (updateError) {
        throw updateError;
      }

      response = data;
      enqueueSnackbar("Message updated successfully!", {
        variant: "success",
      });
    } else {
      // If the template does not exist, insert it
      const { data, error: insertError } = await supabaseClient
        .from("saved_email_templates")
        .insert([
          {
            subject: campaignMessage?.subject,
            message: campaignMessage?.message,
            campaign_id: campaignMessage?.campaign_id,
            user_id: campaignMessage?.user_id,
            message_id: campaignMessage?.message_id,
            sequence_id: campaignMessage?.sequence_id,
          },
        ]);

      if (insertError) {
        throw insertError;
      }

      response = data;
      enqueueSnackbar("Message saved successfully!", {
        variant: "success",
      });
    }

    return response;
  } catch (error) {
    enqueueSnackbar(`Error saving message: ${error.message}`, {
      variant: "error",
    });
  }
}

export async function getAllCampaignMessages(): Promise<
  CampaignMessages[] | null
> {
  try {
    const { data, error } = await supabaseClient
      .from("email_templates")
      .select("*");

    if (error) {
      throw error;
    }
    return data as CampaignMessages[];
  } catch (error) {
    enqueueSnackbar(`Error fetching campaign messages: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}

export async function getAllSavedMessages(): Promise<
  CampaignMessages[] | null
> {
  try {
    const { data, error } = await supabaseClient
      .from("saved_email_templates")
      .select("*");

    if (error) {
      throw error;
    }
    return data as CampaignMessages[];
  } catch (error) {
    enqueueSnackbar(`Error fetching campaign messages: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}


export async function updateMessageById(
  id: number,
  newMessage: string
): Promise<CampaignMessages | null> {


  try {
    const { data, error } = await supabaseClient
      .from("email_templates")
      .update({ message: newMessage })
      .eq("id", id)
      .single(); 

    if (error) {
      console.log(error)
      throw error; // If there's an error, throw it
    }

    console.log("Updated message:", data); // Log the updated message
    return null; // Return the updated message as CampaignMessages
  } catch (error) {
    enqueueSnackbar(`Error updating message: ${error.message}`, {
      variant: "error",
    });
    return null; 
  }
}

export async function getCampaignMessageById(
  messageId: number
): Promise<CampaignMessages | null> {
  try {
    const { data, error } = await supabaseClient
      .from("email_templates")
      .select("*")
      .eq("id", messageId)
      .single(); // Ensure that only one result is returned

    if (error) {
      throw error;
    }

    return data as CampaignMessages;
  } catch (error) {
    enqueueSnackbar(`Error fetching campaign message: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}
export async function editCampaignMessage(
  id: number,
  updatedMessage: Partial<CampaignMessages>
): Promise<CampaignMessages | null> {
  try {
    const { data, error } = await supabaseClient
      .from("email_templates")
      .update({
        subject: updatedMessage.subject,
        message: updatedMessage.message,
        campaign_id: updatedMessage.campaign_id,
      })
      .eq("id", id);

    if (error) {
      throw error;
    }

    enqueueSnackbar("Message updated successfully!", {
      variant: "success",
    });
    return data;
  } catch (error) {
    enqueueSnackbar(`Error updating message: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}

export async function getAllPublishedCampaignMessages(): Promise<
  CampaignMessages[] | null
> {
  try {
    const { data, error } = await supabaseClient
      .from("published_templates")
      .select("*");

    if (error) {
      throw error;
    }
    return data as CampaignMessages[];
  } catch (error) {
    enqueueSnackbar(`Error fetching campaign messages: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}
export async function fetchCampaignsWithTargetMarkets(): Promise<
  Campaign[] | null
> {
  try {
    const { data, error } = await supabaseClient.from("campaign").select(`
        id,
        name,
        status,
        is_active,
        message_type,
        admin_name,
        is_new,
        created_at,
        campaign_targetMarkets (
          targetMarkets(id)
        )
      `);

    if (error) {
      console.error("Error fetching campaigns:", error);
      return null;
    }

    const transformedData = data.map((campaign: any) => ({
      ...campaign,
      campaign_targetMarkets: campaign.campaign_targetMarkets.map(
        (ctm: any) => ({
          targetMarkets: ctm.targetMarkets[0],
        })
      ),
    }));

    console.log("Transformed Campaigns with Target Markets:", transformedData);
    return transformedData as Campaign[];
  } catch (error) {
    console.error("Error fetching campaigns:", error);
    return null;
  }
}

export async function updateCampaignStatus(
  id: number,
  newStatus: string
): Promise<void> {
  try {
    const { error } = await supabaseClient
      .from("campaign")
      .update({ status: newStatus })
      .eq("id", id);

    if (error) {
      throw error;
    }

    enqueueSnackbar("Status updated successfully!", {
      variant: "success",
    });
  } catch (error: any) {
    enqueueSnackbar(`Error updating status: ${error.message}`, {
      variant: "error",
    });
  }
}
export async function updateCampaignStatus1(
  id: number,
  newStatus: string
): Promise<void> {
  try {
    const { error } = await supabaseClient
      .from("campaign")
      .update({ is_new: newStatus })
      .eq("id", id);

    if (error) {
      throw error;
    }
  } catch (error: any) {
    //   enqueueSnackbar(`Error updating status: ${error.message}`, {
    //     variant: "error",
    //   });
  }
}
